import { Box, Button, Card, CircularProgress, debounce, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton, InputLabel, Skeleton, Switch, List, ListItem, ListItemText, Divider } from '@mui/material';
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSelect from 'components/MDSelect';
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from 'components/MDTypography';
import { useMaterialUIController } from "context";
import { useUser } from 'context/UserContext';
import { useEffect, useState } from 'react';
import { cleanFormatCNPJ, errorAlert, formatarNumeroCNJ, successAlert } from 'utils/Functions';
import { get, post, postNoResponse } from 'utils/WebService';
import BasicRegistration from './tabs/BasicRegistration';
import ChildProcess from './tabs/ChildProcess/ChildProcess';
import Deadlines from './tabs/Deadlines/Deadlines';
import MovimentationProcess from './tabs/Movimentations/MovimentationProcess';
import PeopleProcess from './tabs/Peoples/PeopleProcess';
import Pledge from './tabs/Pledge';
import ProcessDocuments from './tabs/Documents/ProcessDocuments';
import { ESCURO } from "assets/coresTema";

export default function CasesCreateEdit({
    id,
    closeCreateEdit,
    isProcessMain = false,
    isProcessChild = false,
    initialTab = null,
    idDeadLine = null,
    table = null
}) {
    const { tipoCasoEnum, sistemasEnum, userGestor, tipoSistemaEnum } = useUser()
    const [temFilhos, setTemFilhos] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const tabData = [
        {
            eventKey: 'cadastroBasico',
            title: 'Cadastro Básico',
            children: (props) => <BasicRegistration {...props} processoEletronico={filters.processoEletronico} reloadData={() => handleData(id)} handleOpenContratos={handleOpenContratos} />
        },
        {
            eventKey: 'pessoas', title: 'Partes do Processo',
            children: (props) => <PeopleProcess {...props} />
        },
        {
            eventKey: 'movimentações', title: 'Movimentações',
            children: (props) => <MovimentationProcess {...props} />
        },
        {
            eventKey: 'penhora', title: 'Penhora',
            children: (props) => <Pledge {...props} />
        },
        {
            eventKey: 'documentos', title: 'Documentos',
            children: (props) => <ProcessDocuments {...props} />
        },
        ...(temFilhos ? [{
            eventKey: 'ChildProcess', title: 'Processos Filhos',
            children: (props) => <ChildProcess {...props} onViewProcessMain={handleViewProcessMain} />
        }] : []),
        ...(userGestor ? [{
            eventKey: 'Deadlines',
            title: 'Eventos',
            children: (props) => <Deadlines {...props} idDeadLine={idDeadLine} table={table} />
        }] : [])
    ];

    const [activeMainTab, setActiveMainTab] = useState(initialTab || tabData[0].eventKey);
    const [isLoadingInfoCliente, setIsLoadingInfoCliente] = useState(false);
    const [clienteList, setClienteList] = useState([]);
    const [salvandoProcesso, setSalvandoProcesso] = useState(false);
    const [salvandoProcessoManual, setSalvandoProcessoManual] = useState(false);
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [viewProcessMain, setViewProcessMain] = useState(false);
    const [selectedProcessMain, setSelectedMain] = useState(null);
    const [isChildProcess, setIsChildProcess] = useState(false);
    const [openSuspensao, setOpenSuspensao] = useState(false);
    const [loadingSuspensao, setLoadingSuspensao] = useState(false);
    const [systems, setSystem] = useState([]);
    const [isLoadingSystem, setIsLoadingSystem] = useState(false);

    const [suspensaoData, setSuspensaoData] = useState({
        motivoSuspensao: "",
        dataInicioSuspensao: "",
        dataFimSuspensao: "",
        usuarioSuspensaoNome: null
    });

    const [openContratoModal, setOpenContratoModal] = useState(false);
    const [contratosJudiciais, setContratosJudiciais] = useState([]);
    const [loadingContratos, setLoadingContratos] = useState(false);
    const [vinculandoContrato, setVinculandoContrato] = useState(false);

    let dataFilters = {
        cliente: null,
        parteContraria: null,
        processo: null,
        tipoCaso: null,
        processoEletronico: null,
        suspenso: false,
        tipoSistema: null
    }

    const [filters, setFilters] = useState(dataFilters);

    useEffect(() => {
        if (id) {
            handleData(id)
        }
    }, [id]);


    function handleData(id) {
        setIsLoadingInfo(true);
        get(`/processo-resume/by-id/${id}`).then(data => {
            setTemFilhos(data.temFilhos)
            setFilters({
                ...data,
                processo: formatarNumeroCNJ(data.processo),
                tipoCaso: tipoCasoEnum.find(x => x.code === data?.tipoCaso),
                processoEletronico: sistemasEnum.find(x => x.code === data?.processoEletronico),
                suspenso: data.suspenso,
                tipoSistema: tipoSistemaEnum.find(x => x.code === data?.tipoSistema),
            });
            setIsLoadingInfo(false);
        }).catch((erro) => {
            setFilters(dataFilters)
            console.error(erro)
            errorAlert("Caso não encontrado!", closeCreateEdit)
            setIsLoadingInfo(false);
        });
    }

    function initProcesso(data, isManual = false) {

        if (isManual) {
            setSalvandoProcessoManual(true);
        } else {
            setSalvandoProcesso(true);
        }

        post("/processo-cadastro-basico/init", {
            cliente: data.cliente,
            parteContraria: data.parteContraria,
            processo: cleanFormatCNPJ(data.processo),
            tipoCaso: data.tipoCaso?.code,
            notificar: data?.notificar,
            processoEletronico: data?.processoEletronico?.code,
            tipoSistema: data?.tipoSistema?.code,
            criarManual: isManual
        }).then(() => {
            successAlert("Processo criado!", () => {
                closeCreateEdit();
            })
        }).catch(({ message }) => {
            errorAlert(message, () => { })
        }).finally(() => {
            if (isManual) {
                setSalvandoProcessoManual(true);
            } else {
                setSalvandoProcesso(true);
            }
        })

    }

    function saveCasoProcessual(data) {
        setSalvandoProcesso(true);
        let payload = {
            id: id,
            cliente: data.cliente,
            parteContraria: data.parteContraria,
            processo: cleanFormatCNPJ(data.processo),
            tipoCaso: data.tipoCaso?.code,
            processoEletronico: data?.processoEletronico.code,
            tipoSistema: data?.tipoSistema?.code
        }
        postNoResponse("/processo/save", payload).then(() => {
            successAlert("Processo salvo com sucesso!", () => { })
        }).catch(e => {
            console.error(e)
            errorAlert("Erro", () => { })
        }).finally(() => {
            setSalvandoProcesso(false);
        })

    }

    useEffect(() => {
        setIsLoadingInfoCliente(true)
        get("/pessoa/list-all")
            .then(({ list }) => {
                setClienteList(list);
                setIsLoadingInfoCliente(false)
            }).catch(() => {
                setClienteList([]);
                setIsLoadingInfoCliente(false)
            });
    }, []);

    const buscarClientes = async (inputValue) => {
        if (!inputValue) return;
        try {
            setIsLoadingInfoCliente(true);
            const { list } = await get("/pessoa/list-all", {
                params: { search: inputValue }
            });
            setClienteList(list);
        } catch {
            setClienteList([]);
        } finally {
            setIsLoadingInfoCliente(false);
        }
    };

    function handleOpenSuspensao() {
        if (filters?.suspenso) {
            setLoadingSuspensao(true);
            get(`/processo/by-id-suspensao/${id}`)
                .then((data) => {
                    setSuspensaoData({
                        motivoSuspensao: data.motivoSuspensao ?? "",
                        dataInicioSuspensao: data.dataInicioSuspensao ?? "",
                        dataFimSuspensao: data.dataFimSuspensao ?? "",
                        usuarioSuspensao: data.usuarioSuspensao ?? null
                    });
                    setOpenSuspensao(true);
                })
                .finally(() => setLoadingSuspensao(false));
        } else {
            setSuspensaoData({
                motivoSuspensao: "",
                dataInicioSuspensao: "",
                dataFimSuspensao: "",
                usuarioSuspensaoNome: null
            });
            setOpenSuspensao(true);
        }
    }

    function handleSalvarSuspensao() {
        setLoadingSuspensao(true);

        const payload = {
            id,
            motivoSuspensao: suspensaoData.motivoSuspensao,
            dataInicioSuspensao: suspensaoData.dataInicioSuspensao,
            dataFimSuspensao: suspensaoData.dataFimSuspensao,
            suspenso: !filters.suspenso
        };

        postNoResponse("/processo/suspender", payload)
            .then(() => {
                successAlert("Processo atualizado com sucesso!");
                setFilters({ ...filters, suspenso: !filters.suspenso });
                setOpenSuspensao(false);
            })
            .catch(() => {
                errorAlert("Erro ao atualizar suspensão");
            }).finally(() => {
                setLoadingSuspensao(false);
            });
    }

    const buscarClientesDebounced = debounce(buscarClientes, 300);

    const renderSidenavItems = tabData.map(({ eventKey, title }, key) => {
        const itemKey = `item-${key}`;

        if (!id && eventKey == 'pessoas') return null
        const isSelected = activeMainTab === eventKey;

        return (
            <MDBox
                key={eventKey}
                display="flex"
                justifyContent="start"
                sx={{ overflow: "auto", p: "0.10rem", mb: -0.2 }}
            >
                <Card
                    sx={{
                        marginRight: 0.25,
                        minWidth: "auto",
                        background: isSelected ? "" : "transparent",
                        borderRadius: "5px 5px 0px 0px",
                        boxShadow: isSelected ? "2px -1px 5px rgba(0,0,0,0.3)" : "3px 0px 5px rgba(0,0,0,0.1)",
                    }}
                >
                    <MDBox display="flex">
                        <Button
                            fullWidth
                            onClick={() => setActiveMainTab(eventKey)}
                            style={{
                                paddingLeft: 16,
                                color: isSelected ? "white" : "inherit", // texto branco na aba ativa
                                fontWeight: isSelected ? 600 : 400,
                            }}
                        >
                            <MDTypography
                                variant="body2"
                                fontWeight="regular"
                                sx={{
                                    whiteSpace: "nowrap",
                                    fontSize: 12,
                                }}
                            >
                                {title}
                            </MDTypography>
                        </Button>
                    </MDBox>
                </Card>
            </MDBox>
        );
    });


    function handleViewProcessMain(id, isChildProcess) {
        setIsChildProcess(isChildProcess)
        setSelectedMain(id)
        setViewProcessMain(true);
    }

    function handleClose() {
        setIsChildProcess(false)
        setSelectedMain(null)
        setViewProcessMain(false);
    }

    function findSystems(typeSystem) {
        setIsLoadingSystem(true)
        get(`/processo/find-type-system/${typeSystem}`)
            .then((data) => {
                setSystem(data);
                setIsLoadingSystem(false);
            }).catch(() => {
                setSystem([]);
                setIsLoadingSystem(false);
            });
    }

    const handleOpenContratos = () => {
        setOpenContratoModal(true);
        setLoadingContratos(true);
        get(`/processo/${id}/contratos-judiciais`)
            .then((data) => setContratosJudiciais(data))
            .catch(() => setContratosJudiciais([]))
            .finally(() => setLoadingContratos(false));
    };

    const handleVincularContrato = (idContrato) => {
        setVinculandoContrato(true);
        postNoResponse(`/processo/${id}/vincular-contrato/${idContrato}`)
            .then(() => {
                successAlert("Contrato vinculado com sucesso!");
                setOpenContratoModal(false);
                handleData(id);
            })
            .catch(() => errorAlert("Erro ao vincular contrato!"))
            .finally(() => setVinculandoContrato(false));
    };

    return (
        <Grid container display="flex" justifyContent="center">
            {viewProcessMain &&
                <Grid item xs={12} md={12}>
                    <CasesCreateEdit
                        id={selectedProcessMain}
                        closeCreateEdit={handleClose}
                        isProcessMain
                        isProcessChild={isChildProcess} />
                </Grid>
            }

            <Dialog
                open={openSuspensao}
                onClose={() => setOpenSuspensao(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? ESCURO.cartao : "#fff",
                        color: darkMode ? "#fff" : "#344767",
                        borderRadius: 2
                    }
                }}
            >
                <DialogTitle>
                    {filters?.suspenso ? "Detalhes da Suspensão" : "Suspender Processo"}
                </DialogTitle>

                <DialogContent dividers>
                    {filters?.suspenso && suspensaoData.usuarioSuspensaoNome && (
                        <MDTypography variant="body2" mb={2}>
                            Suspenso por: <b>{suspensaoData.usuarioSuspensaoNome}</b>
                        </MDTypography>
                    )}

                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2, mt: 2 }}>Motivo da Suspensão</InputLabel>
                    <MDInput
                        size="small"
                        fullWidth
                        multiline
                        rows={3}
                        value={suspensaoData.motivoSuspensao}
                        onChange={(e) =>
                            setSuspensaoData({ ...suspensaoData, motivoSuspensao: e.target.value })
                        }
                        sx={{ mb: 2 }}
                    />

                    <Grid item xs={12} sm={12} mb={2}>
                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Início</InputLabel>
                        <MDTextFieldCalendar
                            name="dataInicio"
                            type="date"
                            fullWidth
                            value={suspensaoData.dataInicioSuspensao}
                            onChange={(e) =>
                                setSuspensaoData({ ...suspensaoData, dataInicioSuspensao: e.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            darkMode={darkMode}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Fim</InputLabel>
                        <MDTextFieldCalendar
                            name="dataFim"
                            type="date"
                            fullWidth
                            value={suspensaoData.dataFimSuspensao}
                            onChange={(e) =>
                                setSuspensaoData({ ...suspensaoData, dataFimSuspensao: e.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            darkMode={darkMode}
                        />

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <MDButton variant="outlined" onClick={() => setOpenSuspensao(false)} disabled={loadingSuspensao}>
                        Cancelar
                    </MDButton>

                    <MDButton
                        variant="contained"
                        color="info"
                        onClick={handleSalvarSuspensao}
                        disabled={loadingSuspensao}
                        startIcon={
                            loadingSuspensao ? (
                                <CircularProgress size={16} color="inherit" />
                            ) : null
                        }
                    >
                        {filters?.suspenso ? "Retirar Suspensão" : "Suspender"}
                    </MDButton>

                </DialogActions>
            </Dialog>

            <Dialog
                open={openContratoModal}
                onClose={() => setOpenContratoModal(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? ESCURO.cartao : "#fff",
                        color: darkMode ? "#fff" : "#344767",
                        borderRadius: 2
                    }
                }}
            >
                <DialogTitle>Vincular a Contrato Judicial</DialogTitle>
                <DialogContent dividers>
                    {loadingContratos ? (
                        <Box display="flex" justifyContent="center" p={3}>
                            <CircularProgress />
                        </Box>
                    ) : contratosJudiciais.length === 0 ? (
                        <MDTypography variant="body2" align="center" p={3}>
                            Nenhum contrato judicial disponível para o cliente deste processo.
                        </MDTypography>
                    ) : (
                        <List>
                            {contratosJudiciais.map((contrato, index) => (
                                <Box key={contrato.id}>
                                    <ListItem 
                                        sx={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                        <ListItemText
                                            primary={
                                                <MDTypography variant="button" fontWeight="medium">
                                                    Contrato: {contrato.titulo}
                                                </MDTypography>
                                            }
                                            secondary={
                                                <>
                                                    <MDTypography variant="caption" display="block">
                                                        Carteira: {contrato.nomeCarteira || "N/A"}
                                                    </MDTypography>
                                                    <MDTypography variant="caption" display="block">
                                                        Valor: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(contrato.valorOriginal)}
                                                    </MDTypography>
                                                    {contrato.idProcesso && (
                                                        <MDTypography variant="caption" color="warning" display="block">
                                                            Já vinculado ao processo: {contrato.numeroProcesso}
                                                        </MDTypography>
                                                    )}
                                                </>
                                            }
                                        />
                                        <MDButton
                                            variant="outlined"
                                            color="info"
                                            size="small"
                                            disabled={vinculandoContrato || contrato.idProcesso === id}
                                            onClick={() => handleVincularContrato(contrato.id)}
                                        >
                                            {contrato.idProcesso === id ? "Vinculado" : "Vincular"}
                                        </MDButton>
                                    </ListItem>
                                    {index < contratosJudiciais.length - 1 && <Divider />}
                                </Box>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions>
                    <MDButton variant="outlined" onClick={() => setOpenContratoModal(false)}>
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Grid item xs={12} md={12} sx={{ display: viewProcessMain ? "none" : "" }}>
                <MDBox>
                    <Card id="user-info">
                        <Box display="flex" alignItems="center" justifyContent="space-between" p={3}>
                            <Box display="flex" alignItems="center">
                                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                                    <MDTypography variant="h5">
                                        <Icon>arrow_back</Icon>
                                    </MDTypography>
                                </IconButton>
                                <MDTypography variant="h6">{id ? "Editar " : "Adicionar "} {isProcessChild ? "Processo Filho" : (isProcessMain ? "Processo Principal" : "Processo")}</MDTypography>
                            </Box>
                        </Box>
                        <MDBox px={3}>
                            <Grid container spacing={2}>
                                {id && filters?.cliente?.nomeComum && (
                                    <Grid item xs={12} sm={12}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Cliente</InputLabel>
                                        <MDInput
                                            size="small"
                                            fullWidth
                                            disabled
                                            value={filters.cliente.nomeComum}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={3}>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>N° Processo</InputLabel>
                                    <MDInput
                                        size="small"
                                        required
                                        placeholder="Informe o nº do processo..."
                                        value={filters.processo ?? ""}
                                        onChange={({ target }) => setFilters({ ...filters, processo: target.value })}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Parte Contrária</InputLabel>
                                    <MDInput
                                        size="small"
                                        placeholder="Informe a parte contrária..."
                                        value={filters.parteContraria ?? ""}
                                        onChange={({ target }) => setFilters({ ...filters, parteContraria: target.value })}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo do Processo</InputLabel>
                                    <MDSelect
                                        getOptionValue={option => option.code}
                                        getOptionLabel={option => option.name}
                                        name='tipoCaso'
                                        placeholder='Selecione'
                                        value={filters.tipoCaso}
                                        options={tipoCasoEnum}
                                        onChange={selectedOptions => {
                                            setFilters({ ...filters, tipoCaso: selectedOptions })
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo de Sistema</InputLabel>
                                    <MDSelect
                                        isLoading={isLoadingInfo}
                                        getOptionValue={option => option.code}
                                        getOptionLabel={option => option.name}
                                        name="tipoSistema"
                                        placeholder="Selecione"
                                        value={filters.tipoSistema}
                                        options={tipoSistemaEnum}
                                        onChange={selectedOptions => {
                                            setFilters({ ...filters, tipoSistema: selectedOptions, processoEletronico: null })
                                            findSystems(selectedOptions?.code)
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Processo Eletrônico</InputLabel>
                                    <MDSelect
                                        isLoading={isLoadingSystem}
                                        getOptionValue={option => option.code}
                                        getOptionLabel={option => option.name}
                                        name="processoEletronico"
                                        placeholder="Selecione"
                                        value={filters.processoEletronico}
                                        options={systems}
                                        onChange={selectedOptions => {
                                            setFilters({ ...filters, processoEletronico: selectedOptions })
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    container
                                    xs={12}
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ px: 2, py: 3 }}
                                >
                                    {/* Botão Suspender */}
                                    {id && (
                                        <Grid item>
                                            <MDButton
                                                variant="contained"
                                                color="info"
                                                onClick={handleOpenSuspensao}
                                            >
                                                {filters?.suspenso ? "Retirar Suspensão" : "Suspender Processo"}
                                            </MDButton>
                                        </Grid>
                                    )}

                                    {/* Processo Pai */}
                                    {filters?.processoPai?.processo && (
                                        <Grid item pl={3}>
                                            <MDButton
                                                variant="outlined"
                                                color="info"
                                                onClick={() =>
                                                    handleViewProcessMain(filters?.processoPai?.id, false)
                                                }
                                                endIcon={<Icon>visibility</Icon>}
                                            >
                                                {filters?.processoPai?.processo}
                                            </MDButton>
                                        </Grid>
                                    )}

                                    {/* Área direita */}
                                    <Grid item xs display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                                        {/* Switch */}
                                        {!id && (
                                            isLoadingInfo ? (
                                                <Skeleton width={200} />
                                            ) : (
                                                <Box display="flex" alignItems="center">
                                                    <MDTypography variant="button">
                                                        Receber notificação
                                                    </MDTypography>
                                                    <Switch
                                                        checked={filters?.notificar ?? false}
                                                        onChange={(e) =>
                                                            setFilters({ ...filters, notificar: e.target.checked })
                                                        }
                                                        sx={{
                                                            ml: 2,
                                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                                color: '#557cff',
                                                            },
                                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                backgroundColor: '#557cff',
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            )
                                        )}

                                        {/* Botão principal */}
                                        <MDButton
                                            disabled={
                                                !filters.tipoCaso ||
                                                !filters.processo ||
                                                !filters.processoEletronico ||
                                                !filters.tipoSistema
                                            }
                                            variant="contained"
                                            color="info"
                                            onClick={() =>
                                                id ? saveCasoProcessual(filters) : initProcesso(filters, false)
                                            }
                                            endIcon={
                                                salvandoProcesso && (
                                                    <CircularProgress color="inherit" size={20} />
                                                )
                                            }
                                        >
                                            {!salvandoProcesso &&
                                                (id ? "Salvar Caso Processual" : "Inicializar Processo")}
                                        </MDButton>

                                        {/* Inicializar Manual */}
                                        {!id && (
                                            <MDButton
                                                disabled={
                                                    !filters.tipoCaso ||
                                                    !filters.processo ||
                                                    !filters.processoEletronico ||
                                                    !filters.tipoSistema
                                                }
                                                variant="contained"
                                                color="info"
                                                onClick={() => initProcesso(filters, true)}
                                                endIcon={
                                                    salvandoProcessoManual && (
                                                        <CircularProgress color="inherit" size={20} />
                                                    )
                                                }
                                            >
                                                {!salvandoProcessoManual && "Inicializar Manualmente"}
                                            </MDButton>
                                        )}
                                    </Grid>
                                </Grid>

                            </Grid>
                        </MDBox>

                    </Card>
                    {id &&
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} lg={12}>
                                <MDBox display="flex" justifyContent="start" sx={{ overflow: "auto", p: "5px 5px 2px 5px" }}>
                                    {renderSidenavItems}
                                </MDBox>

                                <MDBox mb={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {tabData.map((tab, i) => {
                                                if (activeMainTab == tab.eventKey)
                                                    return (
                                                        <Card key={i}>
                                                            {tab.children?.({
                                                                id
                                                            })}
                                                        </Card>
                                                    )
                                                else return null
                                            })}
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </Grid>
                        </Grid>}
                </MDBox>
            </Grid >
        </Grid >
    );
}



